import { store } from "../../../store";
import { DROPDOWN_KEYS, ROUTE_LABELS } from "../../enums/routing-enums";

export interface ProfileMenuResourceLink {
  /** ROUTE_LABELS key — translate via navigation namespace `linkTitle.<labelKey>` */
  labelKey: string;
  url: string;
}

const EXCLUDED_LABELS = new Set<string>([ROUTE_LABELS.FEEDBACK, ROUTE_LABELS.LOG_OUT]);

/**
 * Returns resource links for the ProfileSelectorMenu resources sub-panel.
 * Reads from the computed menuConfig in the store (resources dropdown),
 * excluding feedback and logout items which are surfaced elsewhere in the menu.
 */
export const getProfileMenuResourceLinks = (): ProfileMenuResourceLink[] => {
  const menuConfig = store.getState().boot.shellConfig?.menuConfig ?? [];
  const resources = menuConfig.find((dropdown) => dropdown.key === DROPDOWN_KEYS.RESOURCES);
  if (!resources) return [];

  return resources.items
    .filter((item) => !EXCLUDED_LABELS.has(item.label) && !item.hideMenu)
    .map((item) => ({ labelKey: item.label, url: item.path }));
};
